import api from './api';

export const getResponseSummary = (params) => api.get('/api/reports/responses/summary', { params });
export const getSegmentedResponses = (params) => api.get('/api/reports/responses/segmented', { params });
export const getMembershipSummary = (params) => api.get('/api/reports/membership/summary', { params });
